import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Data Models
class TrackingData {
  constructor(courier, data) {
    this.courier = courier;
    this.data = data;
  }

  static fromJson(json) {
    return new TrackingData(json.courier, json.data);
  }
}

class SteadfastConsignment {
  constructor({
    createdAt,
    id,
    cusName,
    cusAddress,
    cusPhone,
    codAmount,
    trackId,
    invoice,
    status,
    dmId,
    currentHub,
    userId,
    pointDelivery,
    user,
    rider,
    currenthub,
  }) {
    this.createdAt = createdAt;
    this.id = id;
    this.cusName = cusName;
    this.cusAddress = cusAddress;
    this.cusPhone = cusPhone;
    this.codAmount = codAmount;
    this.trackId = trackId;
    this.invoice = invoice;
    this.status = status;
    this.dmId = dmId;
    this.currentHub = currentHub;
    this.userId = userId;
    this.pointDelivery = pointDelivery;
    this.user = user;
    this.rider = rider;
    this.currenthub = currenthub;
  }

  static fromJson(json) {
    return new SteadfastConsignment({
      createdAt: json['created_at'],
      id: json['id'],
      cusName: json['cus_name'],
      cusAddress: json['cus_address'],
      cusPhone: json['cus_phone'],
      codAmount: json['cod_amount'],
      trackId: json['track_id'],
      invoice: json['invoice'],
      status: json['status'],
      dmId: json['dm_id'],
      currentHub: json['current_hub'],
      userId: json['user_id'],
      pointDelivery: json['point_delivery'],
      user: json['user'] ? User.fromJson(json['user']) : null,
      rider: json['rider'] ? Rider.fromJson(json['rider']) : null,
      currenthub: json['currenthub'] ? CurrentHub.fromJson(json['currenthub']) : null,
    });
  }
}

class User {
  constructor({ id, bName }) {
    this.id = id;
    this.bName = bName;
  }

  static fromJson(json) {
    return new User({ id: json['id'], bName: json['b_name'] });
  }
}

class Rider {
  constructor({ id, name, phone }) {
    this.id = id;
    this.name = name;
    this.phone = phone;
  }

  static fromJson(json) {
    return new Rider({ id: json['id'], name: json['name'], phone: json['phone'] });
  }
}

class CurrentHub {
  constructor({ id, name, phone }) {
    this.id = id;
    this.name = name;
    this.phone = phone;
  }

  static fromJson(json) {
    return new CurrentHub({ id: json['id'], name: json['name'], phone: json['phone'] });
  }
}

class SteadfastTrackingHistory {
  constructor({
    id,
    consignmentId,
    senderId,
    trackingType,
    icon,
    text,
    userType,
    userId,
    deliverymanId,
    adminId,
    updatedBy,
    confirmStatus,
    status,
    hideSender,
    createdAt,
    updatedAt,
    deliveryman,
  }) {
    this.id = id;
    this.consignmentId = consignmentId;
    this.senderId = senderId;
    this.trackingType = trackingType;
    this.icon = icon;
    this.text = text;
    this.userType = userType;
    this.userId = userId;
    this.deliverymanId = deliverymanId;
    this.adminId = adminId;
    this.updatedBy = updatedBy;
    this.confirmStatus = confirmStatus;
    this.status = status;
    this.hideSender = hideSender;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.deliveryman = deliveryman;
  }

  static fromJson(json) {
    return new SteadfastTrackingHistory({
      id: json['id'],
      consignmentId: json['consignment_id'],
      senderId: json['sender_id'],
      trackingType: json['tracking_type'],
      icon: json['icon'],
      text: json['text'],
      userType: json['user_type'],
      userId: json['user_id'],
      deliverymanId: json['deliveryman_id'],
      adminId: json['admin_id'],
      updatedBy: json['updated_by'],
      confirmStatus: json['confirm_status'],
      status: json['status'],
      hideSender: json['hide_sender'],
      createdAt: json['created_at'],
      updatedAt: json['updated_at'],
      deliveryman: json['deliveryman'] ? Deliveryman.fromJson(json['deliveryman']) : null,
    });
  }
}

class Deliveryman {
  constructor({
    id,
    name,
    email,
    username,
    type,
    role,
    level,
    phone,
    altPhone,
    address,
    hubId,
    createdAt,
    updatedAt,
  }) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.username = username;
    this.type = type;
    this.role = role;
    this.level = level;
    this.phone = phone;
    this.altPhone = altPhone;
    this.address = address;
    this.hubId = hubId;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromJson(json) {
    return new Deliveryman({
      id: json['id'],
      name: json['name'],
      email: json['email'],
      username: json['username'],
      type: json['type'],
      role: json['role'],
      level: json['level'],
      phone: json['phone'],
      altPhone: json['alt_phone'],
      address: json['address'],
      hubId: json['hub_id'],
      createdAt: json['created_at'],
      updatedAt: json['updated_at'],
    });
  }
}

class PathaoConsignment {
  constructor({ cusName, cusAddress, cusPhone, invoice, codAmount }) {
    this.cusName = cusName;
    this.cusAddress = cusAddress;
    this.cusPhone = cusPhone;
    this.invoice = invoice;
    this.codAmount = codAmount;
  }

  static fromJson(json) {
    return new PathaoConsignment({
      cusName: json['cus_name'],
      cusAddress: json['cus_address'],
      cusPhone: json['cus_phone'],
      invoice: json['invoice'],
      codAmount: json['cod_amount'],
    });
  }
}

class PathaoTrackingHistory {
  constructor({ datetime, type, title, status, remarks, current_location_text }) {
    this.datetime = datetime;
    this.type = type;
    this.title = title;
    this.status = status;
    this.remarks = remarks;
    this.current_location_text = current_location_text;
  }

  static fromJson(json) {
    return new PathaoTrackingHistory({
      datetime: json['datetime'],
      type: json['type'],
      title: json['title'],
      status: json['status'],
      remarks: json['remarks'],
      current_location_text: json['current_location_text'],
    });
  }
}

function ParcelTrackingPage() {
  const { id } = useParams();
  const [trackId, setTrackId] = useState(id || '');
  const [trackingResponse, setTrackingResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (id) {
      setTrackId(id);
      fetchTrackingData(id);
    }
  }, [id]);

  const fetchTrackingData = async (currentTrackId) => {
    if (!currentTrackId) {
      setErrorMessage('Please enter a tracking ID.');
      return;
    }
    setIsLoading(true);
    setErrorMessage(null);
    setTrackingResponse(null);

    const url = `https://dynamicgadgets-server.sparkx-ai.shop/api/track/${currentTrackId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to load data. Status code: ${response.status}`);
      }
      const jsonResponse = await response.json();

      let parsedData;
      if (jsonResponse.courier === 'steadfast') {
        parsedData = new TrackingData(
          jsonResponse.courier,
          {
            consignment: SteadfastConsignment.fromJson(jsonResponse.data[0]),
            trackingHistory: jsonResponse.data[1].map(x => SteadfastTrackingHistory.fromJson(x))
          }
        );
      } else if (jsonResponse.courier === 'pathao') {
        parsedData = new TrackingData(
          jsonResponse.courier,
          {
            consignment: PathaoConsignment.fromJson(jsonResponse.data.consignment),
            trackingHistory: jsonResponse.data.tracking_history.map(x => PathaoTrackingHistory.fromJson(x))
          }
        );
      } else {
        throw new Error(`Unknown courier type: ${jsonResponse.courier}`);
      }
      setTrackingResponse(parsedData);

    } catch (e) {
      setErrorMessage(`Error loading data: ${e.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    fetchTrackingData(trackId);
  };

  const getSteadfastStatusInfo = (status) => {
    switch (status) {
      case 1:
        return { text: 'Pending', color: 'text-orange-600', bgColor: 'bg-orange-100' };
      case 2:
        return { text: 'Delivered Approval Pending', color: 'text-yellow-600', bgColor: 'bg-yellow-100' };
      case 3:
        return { text: 'Partial Delivered Approval Pending', color: 'text-green-400', bgColor: 'bg-green-100' };
      case 4:
        return { text: 'Cancelled Approval Pending', color: 'text-red-400', bgColor: 'bg-red-100' };
      case 5:
        return { text: 'Unknown Approval Pending', color: 'text-gray-500', bgColor: 'bg-gray-100' };
      case 6:
        return { text: 'Delivered', color: 'text-green-700', bgColor: 'bg-green-100' };
      case 7:
        return { text: 'Partial Delivered', color: 'text-green-500', bgColor: 'bg-green-100' };
      case 8:
        return { text: 'Cancelled', color: 'text-red-600', bgColor: 'bg-red-100' };
      case 9:
        return { text: 'Hold', color: 'text-red-800', bgColor: 'bg-red-100' };
      case 10:
        return { text: 'In Review', color: 'text-purple-700', bgColor: 'bg-purple-100' };
      case 18:
        return { text: 'Delivered by Rider', color: 'text-green-700', bgColor: 'bg-green-100' };
      default:
        return { text: 'Unknown Status', color: 'text-gray-600', bgColor: 'bg-gray-100' };
    }
  };

  const getPathaoStatusColor = (status) => {
    status = status ? status.toLowerCase() : '';
    if (status.includes('delivered')) return { color: 'text-green-700', bgColor: 'bg-green-100' };
    if (status.includes('cancel')) return { color: 'text-red-600', bgColor: 'bg-red-100' };
    if (status.includes('hold')) return { color: 'text-red-800', bgColor: 'bg-red-100' };
    if (status.includes('pending')) return { color: 'text-orange-600', bgColor: 'bg-orange-100' };
    if (status.includes('transit') || status.includes('in review')) return { color: 'text-purple-700', bgColor: 'bg-purple-100' };
    return { color: 'text-gray-600', bgColor: 'bg-gray-100' };
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    } catch (e) {
      return 'Invalid Date';
    }
  };

  const renderInfoRow = (label, value, valueColorClass = 'text-gray-900', isBold = false) => (
    <div className="flex justify-between py-2 border-b border-gray-100 last:border-b-0">
      <span className="text-sm font-medium text-gray-600">{label}:</span>
      <span className={`text-sm ${valueColorClass} ${isBold ? 'font-semibold' : ''} text-right max-w-[60%]`}>
        {value}
      </span>
    </div>
  );

  const renderSteadfastTrackingTimeline = (history) => {
    history.sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt) : null;
      const dateB = b.createdAt ? new Date(b.createdAt) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return dateB.getTime() - dateA.getTime();
    });

    return (
      <div className="space-y-4">
        {history.length === 0 ? (
          <p className="text-center text-gray-500 py-8">No tracking history found.</p>
        ) : (
          history.map((item, index) => {
            const info = getSteadfastStatusInfo(item.status);
            return (
              <div key={item.id || index} className="flex gap-4">
                {/* Timeline Line */}
                <div className="flex flex-col items-center">
                  {index !== 0 && <div className="w-0.5 h-6 bg-gray-200"></div>}
                  <div className={`w-8 h-8 rounded-full ${info.bgColor} flex items-center justify-center flex-shrink-0`}>
                    <svg className={`w-4 h-4 ${info.color}`} fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  {index !== history.length - 1 && <div className="w-0.5 flex-grow bg-gray-200"></div>}
                </div>

                {/* Timeline Content */}
                <div className="flex-grow bg-white rounded-lg border border-gray-200 p-4 mb-4">
                  <p className="font-semibold text-gray-900 mb-1">
                    {item.text || 'No Description'}
                  </p>
                  {item.createdAt && (
                    <p className="text-sm text-gray-500 mb-2">{formatDate(item.createdAt)}</p>
                  )}
                  <div className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${info.bgColor} ${info.color}`}>
                    Status: {info.text}
                  </div>
                  {item.deliveryman && item.deliveryman.name && (
                    <p className="text-sm text-gray-600 mt-2">Rider: {item.deliveryman.name}</p>
                  )}
                  {item.deliveryman && item.deliveryman.phone && (
                    <p className="text-sm text-gray-600">Rider Phone: {item.deliveryman.phone}</p>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  };

  const renderPathaoTrackingTimeline = (history) => {
    history.sort((a, b) => {
      const dateA = a.datetime ? new Date(a.datetime) : null;
      const dateB = b.datetime ? new Date(b.datetime) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return dateB.getTime() - dateA.getTime();
    });

    return (
      <div className="space-y-4">
        {history.length === 0 ? (
          <p className="text-center text-gray-500 py-8">No tracking history found for Pathao.</p>
        ) : (
          history.map((item, index) => {
            const statusInfo = getPathaoStatusColor(item.status);
            return (
              <div key={index} className="flex gap-4">
                {/* Timeline Line */}
                <div className="flex flex-col items-center">
                  {index !== 0 && <div className="w-0.5 h-6 bg-pink-200"></div>}
                  <div className={`w-8 h-8 rounded-full ${statusInfo.bgColor} flex items-center justify-center flex-shrink-0`}>
                    <svg className={`w-4 h-4 ${statusInfo.color}`} fill="currentColor" viewBox="0 0 20 20">
                      <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                      <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
                    </svg>
                  </div>
                  {index !== history.length - 1 && <div className="w-0.5 flex-grow bg-pink-200"></div>}
                </div>

                {/* Timeline Content */}
                <div className="flex-grow bg-white rounded-lg border border-gray-200 p-4 mb-4">
                  <p className="font-semibold text-gray-900 mb-1">
                    {item.title || 'No Title'}
                  </p>
                  {item.datetime && (
                    <p className="text-sm text-gray-500 mb-2">{formatDate(item.datetime)}</p>
                  )}
                  {item.current_location_text && (
                    <p className="text-sm text-gray-600 mb-1">Location: {item.current_location_text}</p>
                  )}
                  {item.remarks && (
                    <p className="text-sm text-gray-600 mb-2">Remarks: {item.remarks}</p>
                  )}
                  <div className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${statusInfo.bgColor} ${statusInfo.color}`}>
                    Status: {item.status || 'Unknown'}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  };

  return (
    <div className="bg-gray-100 min-h-screen py-6">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="bg-gray-800 rounded-lg shadow-sm p-6 mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-white text-center">
            Parcel Tracking {trackingResponse?.courier && `(${trackingResponse.courier.charAt(0).toUpperCase() + trackingResponse.courier.slice(1)})`}
          </h1>
        </div>

        {/* Search Section */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="text"
              placeholder="Enter Tracking ID"
              value={trackId}
              onChange={(e) => setTrackId(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="flex-grow px-4 py-3 border-2 border-gray-300 rounded-md text-base focus:outline-none focus:border-amazon-orange focus:ring-2 focus:ring-orange-200 transition-all"
            />
            <button
              onClick={handleSearch}
              className="px-8 py-3 bg-amazon-yellow hover:bg-yellow-500 text-gray-900 font-semibold rounded-md transition-all shadow-md border border-yellow-600"
            >
              Track Parcel
            </button>
          </div>
        </div>

        {/* Loading State */}
        {isLoading && (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <div className="inline-block w-12 h-12 border-4 border-orange-200 border-t-amazon-orange rounded-full animate-spin mb-4"></div>
            <p className="text-gray-600 text-lg">Loading tracking data...</p>
          </div>
        )}

        {/* Error State */}
        {errorMessage && (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <svg className="w-16 h-16 text-red-600 mx-auto mb-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
            <p className="text-red-600 text-lg mb-4">{errorMessage}</p>
            <button
              onClick={() => fetchTrackingData(trackId)}
              className="bg-amazon-yellow hover:bg-yellow-500 text-gray-900 px-6 py-2 rounded-md font-medium transition-colors border border-yellow-600"
            >
              Try Again
            </button>
          </div>
        )}

        {/* Tracking Results */}
        {trackingResponse && !isLoading && !errorMessage && (
          <div className="space-y-6">
            {/* Consignment Details Card */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b bg-gray-50 border-gray-200">
                <h3 className="text-xl font-bold text-gray-900">
                  Consignment Details
                </h3>
              </div>
              <div className="p-6">
                {trackingResponse.courier === 'steadfast' && (
                  <>
                    {renderInfoRow('Customer Name', trackingResponse.data.consignment.cusName || 'N/A')}
                    {renderInfoRow('Customer Address', trackingResponse.data.consignment.cusAddress || 'N/A')}
                    {renderInfoRow('Customer Phone', trackingResponse.data.consignment.cusPhone || 'N/A')}
                    {renderInfoRow('COD Amount', `৳ ${(trackingResponse.data.consignment.codAmount || 0).toFixed(2)}`)}
                    {renderInfoRow('Invoice', trackingResponse.data.consignment.invoice || 'N/A')}
                    {renderInfoRow(
                      'Status',
                      getSteadfastStatusInfo(trackingResponse.data.consignment.status).text,
                      getSteadfastStatusInfo(trackingResponse.data.consignment.status).color,
                      true
                    )}
                    {renderInfoRow('Business Name', trackingResponse.data.consignment.user?.bName || 'N/A')}
                    {renderInfoRow('Rider', trackingResponse.data.consignment.rider?.name || 'N/A')}
                    {renderInfoRow('Rider Phone', trackingResponse.data.consignment.rider?.phone || 'N/A')}
                    {renderInfoRow('Current Hub', trackingResponse.data.consignment.currenthub?.name || 'N/A')}
                    {renderInfoRow('Hub Phone', trackingResponse.data.consignment.currenthub?.phone || 'N/A')}
                  </>
                )}

                {trackingResponse.courier === 'pathao' && (
                  <>
                    {renderInfoRow('Customer Name', trackingResponse.data.consignment.cusName || 'N/A')}
                    {renderInfoRow('Customer Address', trackingResponse.data.consignment.cusAddress || 'N/A')}
                    {renderInfoRow('Customer Phone', trackingResponse.data.consignment.cusPhone || 'N/A')}
                    {renderInfoRow('COD Amount', `৳ ${(trackingResponse.data.consignment.codAmount || 0).toFixed(2)}`)}
                    {renderInfoRow('Invoice', trackingResponse.data.consignment.invoice || 'N/A')}
                  </>
                )}
              </div>
            </div>

            {/* Tracking History */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <div className="px-6 py-4 border-b bg-gray-50 border-gray-200">
                <h3 className="text-xl font-bold text-gray-900">
                  Tracking History
                </h3>
              </div>
              <div className="p-6">
                {trackingResponse.courier === 'steadfast' && renderSteadfastTrackingTimeline(trackingResponse.data.trackingHistory)}
                {trackingResponse.courier === 'pathao' && renderPathaoTrackingTimeline(trackingResponse.data.trackingHistory)}
              </div>
            </div>
          </div>
        )}

        {/* No Data Found */}
        {!trackingResponse && !isLoading && !errorMessage && trackId && (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <p className="text-gray-600 text-lg">No Data Found for Tracking ID: <strong>{trackId}</strong></p>
          </div>
        )}
      </div>

      {/* Custom CSS for Amazon colors */}
      <style jsx>{`
        .bg-amazon-orange {
          background-color: #ff9900;
        }
        .text-amazon-orange {
          color: #ff9900;
        }
        .border-amazon-orange {
          border-color: #ff9900;
        }
        .bg-amazon-yellow {
          background-color: #ffd814;
        }
        .hover\\:bg-yellow-500:hover {
          background-color: #f7ca00;
        }
        .border-t-amazon-orange {
          border-top-color: #ff9900;
        }
      `}</style>
    </div>
  );
}

export default ParcelTrackingPage;
